<template>
    <div class="ssWebAddrMst">
        <div class="form1">
        <el-form :model="addForm" :rules="rules" ref="addForm" label-width="120px"
            :inline="false" class="demo-ruleForm" size="mini">
            <el-form-item label="模拟器内部名CD" prop="ssemuinnamecd">
                <el-input v-model="addForm.ssemuinnamecd"></el-input>
            </el-form-item>
            <el-form-item label="模拟器分支名" prop="ssemuinname">
                <el-input v-model="addForm.ssemuinname"></el-input>
            </el-form-item>
            <el-form-item label="区分" prop="sskbn">
                <el-input v-model="addForm.sskbn"></el-input>
            </el-form-item>
            <el-form-item label="网址" prop="sswebaddr">
                <el-input v-model="addForm.sswebaddr"></el-input>
            </el-form-item>
            <el-form-item label="网址直连标记" prop="ssdirect">
                <el-input v-model.number="addForm.ssdirect"></el-input>
            </el-form-item>
        </el-form>
        <el-form :inline="true"> 
            <el-form-item class="as_btn">
                <el-button type="primary" @click="submitForm('addForm')" :disabled="btnFlag">保存</el-button>
                <el-button @click="resetForm()">重置</el-button>
            </el-form-item>
        </el-form>
        </div>
        <el-table :data="tableData" stripe style="width: 100%" size="mini" border>
            <el-table-column prop="ssemuinnamecd" label="SSEMUINNAMECD" width="180"> </el-table-column>
            <el-table-column prop="ssemuinname" label="SSEMUINNAME" width="180"> </el-table-column>
            <el-table-column prop="sskbn" label="SSKBN"> </el-table-column>
            <el-table-column prop="sswebaddr" label="SSWEBADDR"> </el-table-column>
            <el-table-column prop="ssdirect" label="SSDIRECT"> </el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-button size="mini"  @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
            title="⚠警告"
            :visible.sync="dialogVisible2"
            width="30%">
            <span>刪除网址关连需要提供刪除序列號！</span>
            <br>{{ row.sswebaddr}}
            <el-form :inline="true" label-width="120px" ref="seq"> 
                <el-form-item label="序列號" prop="seq">
                    <el-input v-model="addForm.seq"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible2 = false;">取 消</el-button>
                <el-button type="primary" @click="dialogVisible2 = false;dodelete()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'ssWebAddrMst',
  data(){
    const validateAcquaintance = (rule, value, callback) => {
        if (!value) {
            callback();
        }
        if (!Number.isInteger(value)) {
            callback(new Error('请输入数字值'));
        } else {
             var reg = /^[0-9]{1,4}$/; 
            if(!reg.test(value)){ 
                callback(new Error('最多四位数字'));
            } else {
                callback();
            }
        }
    }
    return {
      addForm:{
          ssemuinnamecd:'',//模拟器内部名CD
          ssemuinname:'',//模拟器内部名
          sskbn:'',//区分
          sswebaddr:'',//网址
          ssdirect: '', //网址直连标记
          seq:''
      },
      seq: {seq:''},
      dialogVisible2: false,
      rules: {
            ssdirect: [
                // { min: 0, max: 8, message: '长度最多4位', trigger: 'blur' },
                { validator: validateAcquaintance, trigger: 'blur' }
            ],
            sskbn: [
                { min: 0, max: 8, message: '长度最多8位', trigger: 'blur' },
            ],
        },
      tableData: [],
      btnFlag: false,
      row:{}
    };
  },
  props: {
    msg: String
  },
  methods:{
    resetForm() {//重置表单
        for (const key in this.addForm) {
            this.addForm[key] = '';
        }
        this.addForm.ssemuinnamecd = this.$route.query.ssemuinnamecd;
        this.addForm.ssemuinname = this.$route.query.ssemuname
    },
    submitForm(formName) {//提交表单
        this.$refs[formName].validate((valid) => {
            if (valid) {
                // console.log(this);
                let _this = this;
                _this.btnFlag = true;
                this.$axios.post('/ssBaseController/addWebAddr.do',{..._this.addForm,})
                .then(res => {  //res是返回结果
                    // console.log(res)
                    _this.addForm.sskbn = '';
                    _this.addForm.sswebaddr = '';
                    _this.addForm.ssdirect = '';
                    _this.tableData = res.ssList;
                    _this.$message({//消息提示框
                        message: '保存成功',
                        type: 'success',
                        showClose: true,//是否有关闭按钮
                        duration: 1000 //持续时间
                    });
                    _this.btnFlag = false;
                }).catch(err => { _this.btnFlag = false;console.error(err); })
            } else {
                console.error('error submit!!');
                return false;
            }
        });
    },
    getList(param){
        // this.api({
        //   url: "/article/listArticle",
        //   method: "get",
        //   params: this.listQuery
        // }).then(data => {
        //   this.listLoading = false;
        //   this.list = data.list;
        //   this.totalCount = data.totalCount;
        // })
        let _this = this;
        this.$axios.post('/ssBaseController/jumpWebAddr.do',param)
        .then(res => {  //res是返回结果
            // console.log(res)
            // _this.addForm.ssemuinnamecd = res.eumInNameCd;
            // _this.addForm.ssemuinname = res.eumInName
            _this.tableData = res.ssList;

        })
    },
    handleEdit(index, row){
        this.addForm.ssemuinnamecd = row.ssemuinnamecd
        this.addForm.ssemuinname = row.ssemuinname
        this.addForm.sskbn = row.sskbn
        this.addForm.sswebaddr = row.sswebaddr
        this.addForm.ssdirect = row.ssdirect
        // console.log(index);
    },
    handleDelete(index, row){
        // handleEdit(index, row)
        this.row = row;
        this.dialogVisible2 = true;
        // console.log(index);
    },
    dodelete(){
        let _this = this;
        this.btnFlag = true;
        this.handleEdit(-1, this.row)
        this.$axios.post('/ssBaseController/deleteWebAddr.do',{..._this.addForm,})
        .then(res => {
            _this.$message({ message: res, type: 'success', showClose: true, duration: 1000});
            _this.btnFlag = false;
            setTimeout(() => {
                _this.getList(_this.$route.query)
            }, 1000);
        })
        .catch(err => {
            console.log('服务器连接失败', err);
            _this.btnFlag = false;
        });
    }
  },
  created:function () {
    // alert("组件实例化之后执行，页面尚未显示 ");
    // console.log(this.$route.query);
    this.addForm.ssemuinnamecd = this.$route.query.ssemuinnamecd;
    this.addForm.ssemuinname = this.$route.query.ssemuname
    this.getList(this.$route.query);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ssWebAddrMst{
  height:100%;
  width:1500px;
  margin: 0 auto;
  display:flex;
  justify-content: center;
  align-items: left;
  flex-direction:column;
  /* text-align: left; */
}
.form1{
    width:360px;
    text-align: center;
}
</style>
